var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Application = require('./application/application');
var Router = require('./application/router');

var Index = require('./index/view');
var Overview = require('./overview/layout-view');
var Tool = require('./tool/layout-view');

var MapState = require('./common/map-state.js');

// start the marionette inspector
if (window.__agent) {
  window.__agent.start(Backbone, Marionette);
}

window.UCS = {}; // Global UC Startups object for easier debugging
UCS.App = new Application();

UCS.App.on('before:start', function () {
	UCS.App.setRootLayout();
});




// Set up main view sections
UCS.App.Index = Index;
UCS.App.Overview = Overview;
UCS.App.Tool = Tool;
UCS.App.MapState = new MapState();



UCS.App.on('start', function () {
  UCS.App.Router = new Router();
  
  Backbone.history.start();

  UCS.App.Router.on('route', function(){
    trackPage();
  });

  function trackPage() {
    // Check if Google Analytics script exists
    if(ga){
      var page = Backbone.history.root + Backbone.history.fragment;
      ga('send','pageview', page);
    }
  }

  //Backbone.history.start({pushState: true});
});

// start the Startups app (defined in js/application/application.js)
UCS.App.start();
